import React from 'react';
import { Box, Link, Paper, Step, StepButton, StepLabel, Theme } from '@mui/material';
import { RiArrowDropDownLine } from 'react-icons/ri';
import Spinner from 'common/components/Spinner';
import { useTranslation } from 'services/localization';
import { createStyles, makeStyles } from '@mui/styles';

interface Props {
	count: number;
	onClick: () => void;
	loading: boolean;
}

const LoadMoreStep = (props: Props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const { count, onClick, loading } = props;
	return (
		<Step>
			<StepButton onClick={onClick} sx={{ width: 'auto' }} disabled={loading}>
				<StepLabel
					StepIconComponent={loading ? LoadMoreLoadingIcon : LoadMoreIcon}
					sx={{ paddingY: 0.5, paddingX: 0 }}
					classes={{
						iconContainer: classes.iconContainer,
					}}
				>
					<Link
						component="span"
						underline="hover"
						sx={{ display: 'inline-flex', alignItems: 'center' }}
					>
						{t('common:actions.showXMore', {
							defaultValue: 'Show {{number}} more',
							number: count,
						})}
					</Link>
				</StepLabel>
			</StepButton>
		</Step>
	);
};

const LoadMoreBaseIcon = ({ loading }: { loading?: boolean }) => {
	const classes = useStyles();
	return (
		<Paper
			sx={{
				width: 24,
				height: 24,
				borderRadius: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				marginLeft: '-7px',
				position: 'relative',
				boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
			}}
		>
			<Box component="span" top="-18px" className={classes.borderDivider} />
			<Box component="span" top="-10px" className={classes.borderDivider} />
			{loading ? <Spinner size={16} /> : <RiArrowDropDownLine />}
		</Paper>
	);
};

const LoadMoreLoadingIcon = () => <LoadMoreBaseIcon loading={true} />;

const LoadMoreIcon = () => <LoadMoreBaseIcon />;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		iconContainer: {
			paddingRight: '6px',
		},
		borderDivider: {
			position: 'absolute',
			height: '2px',
			width: '4px',
			backgroundColor: 'white',
		},
	}),
);

export default LoadMoreStep;
